<template>
  <div>
    <custom-email
      :company="company"
      :kf-expiration="kfExpiration"
      :category="category"
      :created="created"
      :active="isActive"
      @update="update"
    />
  </div>
</template>

<script>
import CustomEmail from './custom-email/custom-email.vue';

export default {
  components: {
    CustomEmail,
  },
  props: {
    kfTemplates: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Number,
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      created: false,
      kfExpiration: null,
      categoryName: null,
      isActive: false,
    };
  },
  mounted() {
    this.categoryName = { 1: 'assignment', 2: 'pending', 3: 'expiration', 4: 'answered' };
    this.isActive = this.kfExpiration?.state === 'active';
  },
  beforeMount() {
    this.kfExpiration = this.kfTemplates.find(t => t.category === 'expiration');
    if (this.kfExpiration) this.created = true;
  },
  methods: {
    update() {
      this.$emit('update');
    },
  },
};
</script>

<style>

</style>
